var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#D3E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.85 7H8.65C8.2122 7 7.79255 7.1738 7.48345 7.48345C7.1738 7.79255 7 8.2122 7 8.65C7 9.23465 7 10.0063 7 10.85C7 11.1536 7.2464 11.4 7.55 11.4C7.8536 11.4 8.1 11.1536 8.1 10.85V8.65C8.1 8.50425 8.15775 8.364 8.26115 8.26115C8.364 8.15775 8.50425 8.1 8.65 8.1H10.85C11.1536 8.1 11.4 7.8536 11.4 7.55C11.4 7.2464 11.1536 7 10.85 7ZM7 13.6V16.35C7 16.7878 7.1738 17.2075 7.48345 17.5166C7.79255 17.8262 8.2122 18 8.65 18C9.10485 18 9.673 18 10.3 18C10.6036 18 10.85 17.7536 10.85 17.45C10.85 17.1464 10.6036 16.9 10.3 16.9H8.65C8.50425 16.9 8.364 16.8423 8.26115 16.7389C8.15775 16.636 8.1 16.4958 8.1 16.35V13.6C8.1 13.2964 7.8536 13.05 7.55 13.05C7.2464 13.05 7 13.2964 7 13.6ZM14.15 18H16.35C16.7878 18 17.2075 17.8262 17.5166 17.5166C17.8262 17.2075 18 16.7878 18 16.35C18 15.7654 18 14.9937 18 14.15C18 13.8464 17.7536 13.6 17.45 13.6C17.1464 13.6 16.9 13.8464 16.9 14.15V16.35C16.9 16.4958 16.8423 16.636 16.7389 16.7389C16.636 16.8423 16.4958 16.9 16.35 16.9H14.15C13.8464 16.9 13.6 17.1464 13.6 17.45C13.6 17.7536 13.8464 18 14.15 18ZM18 10.85V8.65C18 8.2122 17.8262 7.79255 17.5166 7.48345C17.2075 7.1738 16.7878 7 16.35 7C15.7654 7 14.9937 7 14.15 7C13.8464 7 13.6 7.2464 13.6 7.55C13.6 7.8536 13.8464 8.1 14.15 8.1H16.35C16.4958 8.1 16.636 8.15775 16.7389 8.26115C16.8423 8.364 16.9 8.50425 16.9 8.65V10.85C16.9 11.1536 17.1464 11.4 17.45 11.4C17.7536 11.4 18 11.1536 18 10.85ZM9.75 13.05H15.25C15.5536 13.05 15.8 12.8036 15.8 12.5C15.8 12.1964 15.5536 11.95 15.25 11.95H9.75C9.4464 11.95 9.2 12.1964 9.2 12.5C9.2 12.8036 9.4464 13.05 9.75 13.05Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.2429192788c4c60500697af8f9e4cb27.svg";
export { ForwardRef as ReactComponent };